package com.starparty.app.astro0

import com.starparty.app.astro0.celestialbodies.CelestialPoint
import com.starparty.app.astro0.celestialbodies.Star

//import java.awt.*;
//import java.io.*;
/**
 * Title:        Starparty Astro-0
 * Description:  Simply astronomy package for starparty.com and sennen-cove-cornwall.uk
 * Copyright:    Copyright (c) 2021
 * Company: starparty.com
 * @author Rob Leeson
 * @version 2.0
 */
class Constellation(
    protected var itsNum: Int,
    var abbreviation: String,
    var name: String,
    data: String
) {
    var stars: MutableList<Star> = mutableListOf()
        protected set
    lateinit var lines: Array<IntArray>
        protected set
    protected var STAR_SEP = '-'
    protected var LINE_SEP = ','

    var titlePoint: CelestialPoint
        protected set

    fun addStar(star: Star) {
        stars.add(star)
    }

 /*   protected fun createLineArray(data: String?) {
        var lineCount = 0
        var starCount = 0
        val lines: Vector<Any?> = Vector<Any?>()
        for (p in 0 until data!!.length) {
            val ch = data[p]
            if (ch == STAR_SEP) {
                starCount++
            } else if (ch == LINE_SEP) {
                starCount++
                lines.add(IntArray(starCount))
                starCount = 0
                lineCount++
            }
        }
        this.lines = arrayOfNulls(lineCount)
        for (l in lines.indices) {
            lines[l] = lines[l] as IntArray
        }
    }
*/
    protected fun makeConstellation(data: String) {

        val allLinesTemp: MutableList<IntArray> = mutableListOf()
        val lineTemp: MutableList<Int> = mutableListOf()
        val sb = StringBuilder()
        for (ch in data) {

            if (ch >= '0' && ch <= '9') {
                ch.toInt()
                sb.append(ch)
            } else if (ch == STAR_SEP) {
                lineTemp.add(sb.toString().toInt())
                sb.clear()
            } else if (ch == LINE_SEP) {
                lineTemp.add(sb.toString().toInt())
                allLinesTemp.add(lineTemp.toIntArray())
                lineTemp.clear()
                sb.clear()
            }
        }

        lines = allLinesTemp.toTypedArray()
     }


    companion object {

        val NAMES = arrayOf(
            arrayOf("And", "6.7", "37.4", "Andromeda"),
            arrayOf("Ant", "151.1", "-31.6", "Antlia"),
            arrayOf("Aps", "236.9", "-77.9", "Apus"),
            arrayOf("Aqr", "332.6", "-7.1", "Aquarius"),
            arrayOf("Aql", "292.2", "5.9", "Aquila"),
            arrayOf("Ara", "259.6", "-51.7", "Ara"),
            arrayOf("Ari", "39.1", "23.7", "Aries"),
            arrayOf("Aur", "83.3", "40.6", "Auriga"),
            arrayOf("Boo", "222.4", "33.1", "Bootes"),
            arrayOf("Cae", "73.0", "-37.3", "Caelum"),
            arrayOf("Cam", "74.0", "60.4", "Camelopardalis"),
            arrayOf("Cnc", "130.2", "19.9", "Cancer"),
            arrayOf("CVn", "191.4", "39.7", "Canes Venatici"),
            arrayOf("CMa", "102.8", "-21.0", "Canis Major"),
            arrayOf("CMi", "113.0", "7.0", "Canis Minor"),
            arrayOf("Cap", "314.4", "-20.0", "Capricornus"),
            arrayOf("Car", "117.1", "-56.3", "Carina"),
            arrayOf("Cas", "9.0", "60.6", "Cassiopeia"),
            arrayOf("Cen", "205.3", "-48.0", "Centaurus"),
            arrayOf("Cep", "330", "63.4", "Cepheus"),
            arrayOf("Cet", "30.4", "-5.7", "Cetus"),
            arrayOf("Cha", "144.8", "-77.7", "Chamaeleon"),
            arrayOf("Cir", "227.2", "-59.6", "Circinus"),
            arrayOf("Col", "88.6", "-37.5", "Columbia"),
            arrayOf("Com", "190.8", "22.5", "Coma Berenices"),
            arrayOf("CrA", "284.1", "-39.6", "Corona Australis"),
            arrayOf("CrB", "236.1", "29.1", "Corona Borealis"),
            arrayOf("Crv", "185.7", "-20.3", "Corvus"),
            arrayOf("Crt", "173.0", "-16.7", "Crater"),
            arrayOf("Cru", "187.8", "-60.3", "Crux"),
            arrayOf("Cyg", "301.0", "36.3", "Cygnus"),
            arrayOf("Del", "307.1", "13.6", "Delphinus"),
            arrayOf("Dor", "78.1", "-59.7", "Dorado"),
            arrayOf("Dra", "238.3", "62.7", "Draco"),
            arrayOf("Equ", "316.2", "7.5", "Equuleus"),
            arrayOf("Eri", "50.0", "-14.7", "Eridanus"),
            arrayOf("For", "40.0", "-28.9", "Fornax"),
            arrayOf("Gem", "105.5", "24.1", "Gemini"),
            arrayOf("Gru", "334.0", "-39.7", "Grus"),
            arrayOf("Her", "254.0", "34.4", "Hercules"),
            arrayOf("Hor", "46.1", "-52.1", "Horologium"),
            arrayOf("Hya", "138.4", "-2.8", "Hydra"),
            arrayOf("Hyi", "29.5", "-72.2", "Hydrus"),
            arrayOf("Ind", "314.9", "-52.4", "Indus"),
            arrayOf("Lac", "334.4", "44.3", "Lacerta"),
            arrayOf("Leo", "160.9", "16.9", "Leo"),
            arrayOf("LMi", "156.5", "34.3", "Leo Minor"),
            arrayOf("Lep", "83.8", "-18.6", "Lepus"),
            arrayOf("Lib", "230.0", "-19.7", "Libra"),
            arrayOf("Lup", "229.6", "-42.1", "Lupus"),
            arrayOf("Lyn", "121.2", "47.0", "Lynx"),
            arrayOf("Lyr", "283.7", "39.6", "Lyra"),
            arrayOf("Men", "80.4", "-73.3", "Mensa"),
            arrayOf("Mic", "315.7", "-35.3", "Microscopium"),
            arrayOf("Mon", "107.25", "-5.74", "Monoceros"),
            arrayOf("Mus", "183.8", "-68.8", "Musca"),
            arrayOf("Nor", "239.7", "-50.7", "Norma"),
            arrayOf("Oct", "303.5", "-83.9", "Octans"),
            arrayOf("Oph", "256.2", "-0.2", "Ophiuchus"),
            arrayOf("Ori", "84.4", "4.2", "Orion"),
            arrayOf("Pav", "291.9", "-62.6", "Pavo"),
            arrayOf("Peg", "337.3", "18.6", "Pegasus"),
            arrayOf("Per", "54.7", "45.3", "Perseus"),
            arrayOf("Phe", "10.0", "-48.2", "Phoenix"),
            arrayOf("Pic", "92.5", "-56.7", "Pictor"),
            arrayOf("Psc", "12.8", "12.7", "Pisces"),
            arrayOf("PsA", "334.4", "-29.9", "Piscis Austrinus"),
            arrayOf("Pup", "115.1", "-35.3", "Puppis"),
            arrayOf("Pyx", "131.6", "-30.2", "Pyxis"),
            arrayOf("Ret", "61.2", "-61.3", "Reticulum"),
            arrayOf("Sge", "299.2", "16.9", "Sagitta"),
            arrayOf("Sgr", "293.8", "-29.6", "Sagittarius"),
            arrayOf("Sco", "251.0", "-30.5", "Scorpius"),
            arrayOf("Scl", "358.7", "-31.2", "Sculptor"),
            arrayOf("Sct", "278.1", "-10.5", "Scutum"),
            arrayOf("Ser", "234.7", "8.5", "Serpens"),
            arrayOf("Sex", "153.4", "-3.4", "Sextans"),
            arrayOf("Tau", "61.6", "18.0", "Taurus"),
            arrayOf("Tel", "275.3", "-46.0", "Telescopium"),
            arrayOf("Tri", "31.2", "31.8", "Triangulum"),
            arrayOf("TrA", "242.2", "-66.6", "Triangulum Australe"),
            arrayOf("Tuc", "349.4", "-62.7", "Tucana"),
            arrayOf("UMa", "159.6", "59.4", "Ursa Major"),
            arrayOf("UMi", "226.5", "82.1", "Ursa Minor"),
            arrayOf("Vel", "141.4", "-48.4", "Vela"),
            arrayOf("Vir", "197.5", "-1.2", "Virgo"),
            arrayOf("Vol", "116.0", "-67.7", "Volans"),
            arrayOf("Vul", "299.6", "25.7", "Vulpecula")
        )

        val ABB = 0
        val NAME = 3
        val RA = 1
        val DEC = 2
        val NUM_OF_CONS = NAMES.size
        val UNKNOWN_CONST = -1
/*
        inline fun <reified T : Any> addStaticMembersTo(source: Any) {
            val c = T::class.js.asDynamic()
            val ownNames = js("Object").getOwnPropertyNames(source) as Array<String>
            val protoNames = js("Object").getOwnPropertyNames(source.asDynamic().constructor.prototype) as Array<String>

            for (name in ownNames + protoNames) {
                c[name] = source.asDynamic()[name]
            }
        }

        // should be at the end of companion object
        init {
            addStaticMembersTo<Constellation>(this)
        }*/
    }


    init {
        val titleRA =
            NAMES[itsNum][RA].toDouble()
        val titleDec =
            NAMES[itsNum][DEC].toDouble()
        titlePoint = CelestialPoint(titleRA, titleDec)
        makeConstellation(data)
    }
}